import type { FC } from 'react'
import styled from '@emotion/styled'

import Image from '@segment/matcha/components/Image'

import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'
import SectionBase, * as Section from '@segment/matcha/recipes/Section'

import ActivateEngagementPng2x from './assets/ActivateEngagement@2x.png'
import ActivateEngagementWebp from './assets/ActivateEngagement.webp'
import ActivateEngagementWebp2x from './assets/ActivateEngagement@2x.webp'

const copy = {
  heading: `Activate engagement that gets better with every customer interaction`,
  description: `Every interaction with each individual customer fuels a deeper, more intimate understanding for who they are and how they engage. This engagement flywheel generates better customer experiences, increased loyalty, and consistently better business outcomes.`,
}

const ActivateEngagement: FC = () => {
  return (
    <SectionBase variant="2Col">
      <SectionCopy>
        <CopyTextBase>
          <CopyText.Heading variant="h2" tag="h2">
            {copy.heading}
          </CopyText.Heading>

          <CopyText.Description variant="pLarge" tag="p">
            {copy.description}
          </CopyText.Description>
        </CopyTextBase>
      </SectionCopy>

      <Section.Contents>
        <picture>
          <source type="image/webp" srcSet={`${ActivateEngagementWebp}, ${ActivateEngagementWebp2x} 2x`} />
          <Image
            src={ActivateEngagementPng2x}
            alt="Illustration: Activate engagement that gets better with every customer interaction"
            width="500"
            height="450"
            loading="lazy"
          />
        </picture>
      </Section.Contents>
    </SectionBase>
  )
}

const SectionCopy = styled(Section.Copy)`
  display: flex;
  align-items: center;

  ${({ theme }) => theme.breakpoints.up(`lg`)} {
    max-width: 440px;
    justify-self: end;
    align-self: center;
  }
`

export default ActivateEngagement
